const convertEnglishDigitsToPersian = str => {
  // make sure it is string
  str = '' + str;
  const map = {
    0: '۰',
    1: '۱',
    2: '۲',
    3: '۳',
    4: '۴',
    5: '۵',
    6: '۶',
    7: '۷',
    8: '۸',
    9: '۹'
  };
  const numbers = str.split('');
  for (let i = 0; i < numbers.length; i++) {
    if (map.hasOwnProperty(numbers[i])) {
      numbers[i] = map[numbers[i]];
    }
  }
  return numbers.join('');
};
const convertNonEnglishDigits = str => {
  if (typeof str === 'undefined' || str === '') {
    return str;
  }
  if (typeof str === 'number') {
    return String(str);
  }
  const map = {
    // arabic
    1632: '0',
    1633: '1',
    1634: '2',
    1635: '3',
    1636: '4',
    1637: '5',
    1638: '6',
    1639: '7',
    1640: '8',
    1641: '9',
    // persian
    1776: '0',
    1777: '1',
    1778: '2',
    1779: '3',
    1780: '4',
    1781: '5',
    1782: '6',
    1783: '7',
    1784: '8',
    1785: '9'
  };
  if (str) {
    const numbers = str.split('');
    for (let i = 0; i < numbers.length; i++) {
      if (map.hasOwnProperty(numbers[i].charCodeAt(0))) {
        numbers[i] = map[numbers[i].charCodeAt(0)];
      }
    }
    return numbers.join('');
  } else return String(str);
};
const convertObjectNumbersToEnglish = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'string') {
      obj[key] = convertNonEnglishDigits(obj[key]);
    }
  });
  return obj;
};
const currencyFormat = (price, separator = '٬') => {
  if (typeof price !== 'string') {
    price = parseInt(price, 10);
  }
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
const panFormat = val => {
  if (val.length <= 18) {
    val = val.replace(/-/ig, '');
    // separate numbers by dash
    val = val.match(new RegExp(/\d{1,4}/, 'g')).join('-');
  }
  return val;
};
function formatIban(val) {
  val = convertNonEnglishDigits(val);
  // remove white spaces
  // remove all non-numeric characters
  val = removeAllNonNumericCharacters(val);
  // prepend IR- if it's not already there
  if (val.indexOf('IR-') < 0 && val.length > 0) {
    // prepend IR- to the value
    val = 'IR-' + val;
  }
  // add whitespaces (format) if
  // the length was more than 4 characters
  if (val && val.length > 4) {
    val = val.match(new RegExp(/IR-\d{2}|\d{1,4}/, 'g')).join(' ');
  }
  return val;
}
function removeAllNonNumericCharacters(val) {
  const reg = new RegExp(/([^0-9]+)/g);
  if (!val) {
    return '';
  }
  return ('' + val).replace(reg, '');
}
const moreReadableCellNumber = string => {
  if (typeof string === 'undefined' || string === '') {
    return '';
  }
  const n = '' + string;
  return n.replace(/^(\d{4})(\d{3})(\d{4})$/g, '$1 $2 $3');
};
const powToStr = [{
  pow: 9,
  label: ' میلیارد'
}, {
  pow: 6,
  label: ' میلیون'
}, {
  pow: 3,
  label: ' هزار'
}];
const tenPow = pow => {
  return Math.pow(10, +pow);
};
const separator = ' و ';
const specialNumbers = {
  1: 'یک'
};
const tinyNumbers = input => {
  if (input <= 0 || input >= 1000) {
    return '';
  }
  if (specialNumbers[input]) {
    return specialNumbers[input];
  }
  return input > 0 ? input.toLocaleString() : '';
};
const numberToString = input => {
  let output = '';
  powToStr.some(item => {
    if (input >= tenPow(item.pow)) {
      output = numberToString(Math.floor(input / tenPow(item.pow)));
      output += item.label;
      output += input % tenPow(item.pow) ? separator + numberToString(Math.floor(input % tenPow(item.pow))) : '';
      return true;
    }
    return false;
  });
  if (output) {
    return output;
  }
  return tinyNumbers(input);
};
const numberAmountToWords = input => {
  let output = '';
  powToStr.some(item => {
    if (input >= tenPow(item.pow)) {
      output = numberAmountToWords(Math.floor(input / tenPow(item.pow)));
      output += item.label;
      output += input % tenPow(item.pow) ? separator + numberAmountToWords(Math.floor(input % tenPow(item.pow))) : '';
      return true;
    }
    return false;
  });
  if (output) {
    return output;
  }
  return tinyNumbers(input);
};
function toPersianChar(input) {
  const mapper = {
    "1603": "ک",
    "1610": "ی",
    "1643": "ر",
    "65136": "",
    "65137": "",
    "65138": "",
    "65139": "",
    "65140": "",
    "65142": "",
    "65143": "",
    "65144": "",
    "65145": "",
    "65146": "",
    "65147": "",
    "65148": "",
    "65149": "",
    "65150": "",
    "65151": "",
    "65152": "",
    "65153": "آ",
    "65154": "آ",
    "65155": "ا",
    "65156": "ا",
    "65157": "و",
    "65158": "و",
    "65159": "ا",
    "65160": "ا",
    "65161": "ی",
    "65162": "ی",
    "65163": "ی",
    "65164": "ی",
    "65165": "ا",
    "65166": "ا",
    "65167": "ب",
    "65168": "ب",
    "65169": "ب",
    "65170": "ب",
    "65171": "ه",
    "65172": "ه",
    "65173": "ت",
    "65174": "ت",
    "65175": "ت",
    "65176": "ت",
    "65177": "ث",
    "65178": "ث",
    "65179": "ث",
    "65180": "ث",
    "65181": "ج",
    "65182": "ج",
    "65183": "ج",
    "65184": "ج",
    "65185": "ح",
    "65186": "ح",
    "65187": "ح",
    "65188": "ح",
    "65189": "خ",
    "65190": "خ",
    "65191": "خ",
    "65192": "خ",
    "65193": "د",
    "65194": "د",
    "65195": "ذ",
    "65196": "ذ",
    "65197": "ر",
    "65198": "ر",
    "65199": "ز",
    "65200": "ز",
    "65201": "س",
    "65202": "س",
    "65203": "س",
    "65204": "س",
    "65205": "ش",
    "65206": "ش",
    "65207": "ش",
    "65208": "ش",
    "65209": "ص",
    "65210": "ص",
    "65211": "ص",
    "65212": "ص",
    "65213": "ض",
    "65214": "ض",
    "65215": "ض",
    "65216": "ض",
    "65217": "ط",
    "65218": "ط",
    "65219": "ط",
    "65220": "ط",
    "65221": "ظ",
    "65222": "ظ",
    "65223": "ظ",
    "65224": "ظ",
    "65225": "ع",
    "65226": "ع",
    "65227": "ع",
    "65228": "ع",
    "65229": "غ",
    "65230": "غ",
    "65231": "غ",
    "65232": "غ",
    "65233": "ف",
    "65234": "ف",
    "65235": "ف",
    "65236": "ف",
    "65237": "ق",
    "65238": "ق",
    "65239": "ق",
    "65240": "ق",
    "65241": "ک",
    "65242": "ک",
    "65243": "ک",
    "65244": "ک",
    "65245": "ل",
    "65246": "ل",
    "65247": "ل",
    "65248": "ل",
    "65249": "م",
    "65250": "م",
    "65251": "م",
    "65252": "م",
    "65253": "ن",
    "65254": "ن",
    "65255": "ن",
    "65256": "ن",
    "65257": "ه",
    "65258": "ه",
    "65259": "ه",
    "65260": "ه",
    "65261": "و",
    "65262": "و",
    "65263": "ی",
    "65264": "ی",
    "65265": "ی",
    "65266": "ی",
    "65267": "ی",
    "65268": "ی",
    "64509": "ی",
    "64510": "ی",
    "64511": "ی",
    "64512": "ی",
    "64342": "پ",
    "64343": "پ",
    "64344": "پ",
    "64345": "پ",
    "64378": "چ",
    "64379": "چ",
    "64380": "چ",
    "64381": "چ",
    "64398": "ک",
    "64399": "ک",
    "64400": "ک",
    "64401": "ک",
    "64402": "گ",
    "64403": "گ",
    "64404": "گ",
    "64405": "گ",
    "64406": "گ",
    "64407": "گ",
    "64408": "گ",
    "64409": "گ",
    "64410": "گ",
    "64411": "گ",
    "64412": "گ",
    "64413": "گ",
    "64426": "ه",
    "64427": "ه",
    "64428": "ه",
    "64429": "ه",
    "64467": "ک",
    "64468": "ک",
    "64469": "ک",
    "64470": "ک",
    "64471": "و",
    "64472": "و",
    "64473": "و",
    "64474": "و",
    "64475": "و",
    "64476": "و",
    "64477": "و",
    "64478": "و",
    "64479": "و",
    "64480": "و",
    "64481": "و",
    "64482": "و",
    "64483": "و",
    "64484": "ی",
    "64485": "ی",
    "64486": "ی",
    "64487": "ی",
    "64488": "ی",
    "64489": "ی"
  };
  const inputCharacters = input.split('');
  for (let i = 0; i < inputCharacters.length; i++) {
    if (mapper.hasOwnProperty(inputCharacters[i].charCodeAt(0))) {
      inputCharacters[i] = mapper[inputCharacters[i].charCodeAt(0)];
    }
  }
  ;
  return inputCharacters.join('');
}
const splitString = (input, sizes) => {
  let parts = [];
  let startIndex = 0;
  for (let size of sizes) {
    if (startIndex >= input.length) break;
    let part = input.substring(startIndex, startIndex + size);
    parts.push(part);
    startIndex += size;
  }
  return parts;
};

/*
 * Public API Surface of strings
 */

/**
 * Generated bundle index. Do not edit.
 */

export { convertEnglishDigitsToPersian, convertNonEnglishDigits, convertObjectNumbersToEnglish, currencyFormat, formatIban, moreReadableCellNumber, numberAmountToWords, numberToString, panFormat, removeAllNonNumericCharacters, splitString, toPersianChar };
